import { BrowserModule } from '@angular/platform-browser';
import { NgModule, Injector } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { Http, HttpModule } from '@angular/http';
import { LocationStrategy, HashLocationStrategy } from '@angular/common';
import { Config, loadConfig } from './config';
import { routing } from "./app.routing";
import { AppComponent } from './app.component';
import { DashboardComponent } from './dashboard.component';
import { FooterComponent } from './footer.component';
import { LoginComponent } from './login.component';
import { AppTitle } from './title';
import { AlertDirective } from './alert.directive';
import { OffClickDirective } from "./off_click.directive";
import { Account, accountServiceFactory } from './account.service';
import { OneRosterService, OneRosterServiceFactory } from './oneroster.service';
import { Auth } from './auth';
import { Angulartics2Module } from 'angulartics2';
import { CatchAllComponent } from './catchall.component';
import { TruncatePipe } from './truncate.pipe';
import { AppToggleComponent } from './app_toggle.component';
import { FileUploadModule } from 'ng2-file-upload';
import { AppImportComponent } from "./app_import.component";
import { AlertYesNoDirective } from './alert-yesno.directive';
import { HttpService, getHttpService } from './http.service';
import { RequestOptions, XHRBackend } from "@angular/http";
import { AppReloadDirective } from './app-reload/app-reload.directive';
import { AppService } from './app.service';
import { RegistrationComponent } from './registration.component';
import { RegistrationAddComponent } from './registration_add.component';
import { SyncComponent } from './sync.component';
import { SchoolMappingComponent } from './school_mapping.component';
import { SftpComponent } from './sftp.component';
import { SftpAddComponent } from './sftp_add.component';
import { SftpSyncComponent } from './sftp_sync.component';

@NgModule({
	declarations: [
		AppComponent,
		DashboardComponent,
		FooterComponent,
		LoginComponent,
		AlertDirective,
		OffClickDirective,
		CatchAllComponent,
		TruncatePipe,
		AppToggleComponent,
		AppImportComponent,
		AlertYesNoDirective,
		AppReloadDirective,
		RegistrationComponent,
		RegistrationAddComponent,
		SyncComponent,
		SchoolMappingComponent,
		SftpComponent,
		SftpAddComponent,
		SftpSyncComponent,
	],
	imports: [
		BrowserModule,
		FormsModule,
		HttpModule,
		routing,
		ReactiveFormsModule,
		Angulartics2Module.forRoot(),
		FileUploadModule
	],
	providers: [
		AppTitle,
		{ provide: LocationStrategy, useClass: HashLocationStrategy },
		{ provide: Account, useFactory: accountServiceFactory, deps: [Config, Http] },
		{ provide: OneRosterService, useFactory: OneRosterServiceFactory, deps: [HttpService, Account, Config] },
		{ provide: Config, useFactory: loadConfig },
		{ provide: HttpService, useFactory: getHttpService, deps: [XHRBackend, RequestOptions, Injector] },
		Auth,
		AppService,
	],
	bootstrap: [AppComponent]
})

export class AppModule { }
